import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "../contexts/ConsentContext";
import { initGA, updateConsent, trackPageView } from "../utils/gtag";

/**
 * Connects consent state to GA4.
 * - Initialises gtag.js on first render (with consent denied by default).
 * - Updates Google Consent Mode whenever user preferences change.
 * - Sends page_view events on route changes (only if analytics is granted).
 */
const useAnalytics = () => {
  const { consent } = useConsent();
  const location = useLocation();

  // Initialise GA4 script once (consent defaults to denied)
  useEffect(() => {
    initGA();
  }, []);

  // Update consent mode whenever preferences change
  useEffect(() => {
    if (!consent) return;
    updateConsent({
      analytics: consent.analytics,
      marketing: consent.marketing,
    });
  }, [consent]);

  // Track page views on route changes
  useEffect(() => {
    if (consent?.analytics) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, consent]);
};

export default useAnalytics;
